
import MainLogo from "../img/ActPolymersLogo@2x.png";
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from "react-router-dom";

import {
  CloseIcon,
  HamburgerIcon,
  ChevronDownIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  IconButton,
  Image,
  Stack,
  useDisclosure,
  Link,
  Collapse,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

export default function Nav() {
  const colors = {
  black: "#000000",
  pink: "#e10ea5",
  yellow: "#d3c615",
  red: "#f21d1b",
  orangeRed: "#f31f1c",
  teal: "#1da179",
  green1: "#1b9872",
  green2: "#1d9e77",
};

  const { isOpen, onClose, onOpen } = useDisclosure();
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const {
    isOpen: isMobileProductsOpen,
    onToggle: onToggleMobileProducts,
  } = useDisclosure();

  const toggleLang = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.dir = newLang === "ar" ? "rtl" : "ltr";
  };

const subProductPages = [
  { label: t("navbar.subProducts.masterbatch"), to: "/masterbatch" },
  { label: t("navbar.subProducts.additives"), to: "/additives" },
  { label: t("navbar.subProducts.calcium"), to: "/calcium-carbonate" },
  { label: t("navbar.subProducts.quotes"), to: "/request-quotes" },
];

const menuItems = [
  { label: t("navbar.home"), to: "/" },
  { label: t("navbar.about"), to: "/about" },
  { label: t("navbar.products"), to: "/products", children: subProductPages },
  { label: t("navbar.contact"), to: "/contact" },
  { label: t("navbar.news"), to: "/news" },
  { label: t("navbar.login"), to: "/admin/login" },
];

  return (
    <Box
      bg={'#fff'}
      position="sticky"
      top="0"
      left="0"
      w="100%"
      zIndex="1000"
      boxShadow={"sm"}
    >
      <Container maxW="container.xl" py={2}>
        <Flex alignItems="center" justifyContent="space-between">
          {/* Mobile Hamburger */}
          <IconButton
            aria-label="Toggle Menu"
            bg="none"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />} 
            onClick={isOpen ? onClose : onOpen}
            display={{ base: "block", md: "none" }}
          />

          {/* Logo */}
          <Flex align="center" p={'2'}>
            <Image src={MainLogo} alt="Main logo" h="40px"/>
          </Flex>

          {/* Desktop Menu */}
          <HStack as="nav" spacing={1} display={{ base: "none", md: "flex" }}>
            {menuItems.map((item) => (
              item.children ? (
                <Menu key={item.to} isLazy>
                  <MenuButton
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                    variant="ghost"
                    fontWeight="medium"
                    _hover={{ color: colors.teal }}
                  >
                    {item.label}
                  </MenuButton>
                  <MenuList>
                    {item.children.map((child) => (
                      <MenuItem
                        key={child.to}
                        as={NavLink}
                        to={child.to}
                      >
                        {child.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Menu>
              ) : (
                <Button
                  key={item.to}
                  as={NavLink}
                  to={item.to}
                  variant="ghost"
                  fontWeight="medium"
                  _hover={{ color: colors.teal }}
                  style={({ isActive }) =>
                    isActive ? { fontWeight: "bold", color: colors.teal } : {}
                  }
                >
                  {item.label}
                </Button>
              )
            ))}
          </HStack>

          {/* Right Section */}
          <HStack spacing={2}>
            <Button size="md" onClick={toggleLang}>
              {i18n.language === "ar" ? "English" : "عربي"}
            </Button>
          </HStack>
        </Flex>

        {/* Mobile Menu Overlay */}
        {isOpen && (
          <Box
            display={{ md: "none" }}
            bg={"#fff"}
            position="absolute"
            top="100%"
            left="0"
            w="100%"
            py={4}
            px={4}
            boxShadow="md"
          >
            <Stack spacing={4}>
              {menuItems.map((item) => (
                item.children ? (
                  <Box key={item.to}>
                    <Button
                      onClick={onToggleMobileProducts}
                      variant="ghost"
                      w="100%"
                      justifyContent="flex-start"
                      rightIcon={<ChevronDownIcon />}
                    >
                      {item.label}
                    </Button>
                    <Collapse in={isMobileProductsOpen} animateOpacity>
                      <Stack pl={4} mt={2} spacing={2}>
                        {item.children.map((child) => (
                          <Button
                            key={child.to}
                            as={NavLink}
                            to={child.to}
                            variant="ghost"
                            w="100%"
                            justifyContent="flex-start"
                            onClick={onClose}
                          >
                            {child.label}
                          </Button>
                        ))}
                      </Stack>
                    </Collapse>
                  </Box>
                ) : (
                  <Button
                    key={item.to}
                    as={NavLink}
                    to={item.to}
                    variant="ghost"
                    w="100%"
                    justifyContent="flex-start"
                    onClick={onClose}
                  >
                    {item.label}
                  </Button>
                )
              ))}
            </Stack>
          </Box>
        )}
      </Container>
    </Box>
  );
}
